
import * as React from "react";
import { IActiveOrders } from "../../../interfaces/IOrder";

interface IOrderRowProps {
    item          : any
    changeOrderId : Function

}


interface IOrderRowState {
}

export default class PendingOrderRow extends React.Component<IOrderRowProps, IOrderRowState>{

    constructor(props:IOrderRowProps){
        super(props);
    }


    render() {
        let item = this.props.item;
        return (
            <div className = "order pending-order" onClick={() => this.props.changeOrderId(this.props.item.id)}>
                <div className = "offer-type-img">
                    <img src = {item.offer.offerType.img}/>
                </div>
                <div className="content">
                    <p className="user-name">{item.creator.firstName} {item.creator.lastName}</p>
                    <div className = "user-phone">
                        {item.creator.phone}
                    </div>
                    <p className = "order-date-range">
                        {item.startDateTime} - {item.endDateTime}
                    </p>

                    <p className = "price">
                        {item.price} {item.currency}
                    </p>
                </div>
            </div>
        );
    }
}
